import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect, withRouter } from "react-router-dom";
import { Alert, Button, Form, FormGroup, Input, Label } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as Records from '../store/Records';
import * as paths from '../data/Paths';
import * as utility from '../data/Utility';

class BillableItemInternal extends React.Component {
    constructor(props) {
        super(props);

		const itemId = utility.propCheck( props.itemId, "" );
		const qty = utility.propCheck( props.qty, "" );
		const code = utility.propCheck( props.code, "" );
		const description = utility.propCheck( props.description, "" );
		const isUorM = utility.propCheck( props.isUorM, "" );
		const price = utility.propCheck( props.price, "" );
		const amount = utility.propCheck( props.amount, "" );
		const studyId = utility.propCheck( props.studyId, null );
		const studyName = utility.propCheck( props.studyName, null );
		const returnPath = utility.propCheck( props.returnPath, paths.billing );
		const error = utility.propCheck( props.error, false );

        this.state = {
			itemId: itemId,
			qty: qty,
			code: code,
			description: description,
			isUorM: isUorM,
			price: price,
			amount: amount,
            error: error,
			needsRefresh: true,
            studyId: studyId,
            studyName: studyName,
            returnPath: returnPath,
        };

        this.handleCancel = this.handleCancel.bind(this);
        this.handleValue = this.handleValue.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.initialize = this.initialize.bind(this);
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
        this.initialize(null);
		if ( ! this.state.needsRefresh ) {
			this.setState({ needsRefresh: true });
		}
    }

    componentDidUpdate(prevProps) {
        this.initialize(prevProps);
    }

    handleCancel() {
		this.setState({ redir: this.state.returnPath });
    }

    handleValue = (e) => {

		/* automatically create a new amount by multiplying the qty and price whenever they change */
		switch ( e.target.id ) {
			case "price":
				this.setState({ amount: (e.target.value * this.state.qty).toFixed(2) });
				break;
			case "qty":
				this.setState({ amount: (e.target.value  * this.state.price).toFixed(2) });
				break;
			default:
				break;
		}
		this.setState({ [e.target.id]: e.target.value });
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.handleSave();
        }
    }

	handleSave() {
		this.setState({
			error: false
		});

		(async () => {
			await this.props.recordsDispatch.updateBillableItem(this.state);
		})().then(() => {
			this.setState({ redir: this.state.returnPath });
		});
	}


    initialize(prevProps) {
        const accountsState = this.props.accountsState;
        const authenticated = Accounts.authenticatedAllRoles(accountsState);
        const recordsState = this.props.recordsState;

        // Fetch billable item, if necessary
        const needToFetch = (
			(
				authenticated
				&& ! recordsState.fetching
				&& ! accountsState.fetching
				&& this.state.needsRefresh
			)
        );

		if ( this.state.itemId !== '' && needToFetch ) {
			(async () => {
				this.setState({ needsRefresh: false });
				await this.props.recordsDispatch.getBillableItem(this.state.itemId);
			})().then(() => {
				const bi = this.props.recordsState.billableItem;
				if ( bi != null ) {
					this.setState({
						qty: bi.qty,
						code: bi.code,
						description: bi.description,
						isUorM: bi.isUorM,
						price: bi.price,
						amount: bi.amount,
						needsRefresh: false,
					});
				}
			});
		}
    }


    render() {
        if (!Accounts.authenticatedAdministrator(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

		if ( this.state.redir ) {
			return (
				<Redirect to={
						{
							pathname: this.state.redir,
							state: {
								studyId: this.state.studyId,
								studyName: this.state.studyName,
								doRefresh: true,
							}
						}
					}
				/>
			);
		}

        const cancel = "Cancel";
        const save = "Save";
        var title = "Billable Item";

        return (
            <Form>
                <h1> {title} </h1>

                {this.state.error && <Alert color="warning">Missing or incorrect fields.</Alert>}

                <FormGroup>
                    <Label for="qty"> Qty </Label>
                    <Input className="input" disabled={false} id="qty" onChange={this.handleValue} onKeyDown={this.handleKeyDown} type="text" value={this.state.qty} />
                </FormGroup>

                <FormGroup>
                    <Label for="code"> Item Code </Label>
                    <Input className="input" disabled={false} id="code" onChange={this.handleValue} onKeyDown={this.handleKeyDown} type="text" value={this.state.code} />
                </FormGroup>

                <FormGroup>
                    <Label for="description"> Description </Label>
                    <Input className="input" disabled={false} id="description" onChange={this.handleValue} onKeyDown={this.handleKeyDown} type="text" value={this.state.description} />
                </FormGroup>

                <FormGroup>
                    <Label for="isUorM"> U/M </Label>
                    <Input className="input" disabled={false} id="isUorM" onChange={this.handleValue} onKeyDown={this.handleKeyDown} type="text" value={this.state.isUorM} />
                </FormGroup>

                <FormGroup>
                    <Label for="price"> Price </Label>
                    <Input className="input" disabled={false} id="price" onChange={this.handleValue} onKeyDown={this.handleKeyDown} type="text" value={this.state.price} />
                </FormGroup>

                <FormGroup>
                    <Label for="amount"> Amount </Label>
                    <Input className="input" disabled={false} id="amount" onChange={this.handleValue} onKeyDown={this.handleKeyDown} type="text" value={this.state.amount} />
                </FormGroup>

				<div className="button-gap">
					<Button className="button" onClick={this.handleSave} title={save}>{save}</Button>{' '}
					<Button className="button" onClick={this.handleCancel} title={cancel}>{cancel}</Button>
				</div>

            </Form>
        );
    }
}

const BillableItemConnect = withRouter(connect(
    state => ({
        accountsState: state.accounts,
        recordsState: state.records,
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        recordsDispatch: bindActionCreators(Records.actionCreators, dispatch),
    })
)(BillableItemInternal));

export default class BillableItem extends React.Component {
    render() {
        var editing = true;
        var returnPath = false;
        var studyId = null;
        var studyName = null;
		var itemId = "";
		var qty = "";
		var code = "";
		var description = "";
		var isUorM = "";
		var price = "";
		var amount = "";

        const propsState = this.props.location.state;
        if (propsState != null) {
            editing = utility.propCheck(propsState.editing, editing);
            returnPath = utility.propCheck(propsState.returnPath, paths.billing);
            studyId = utility.propCheck(propsState.studyId, null);
            studyName = utility.propCheck(propsState.studyName, null);
			itemId = utility.propCheck( propsState.itemId, "" );
			qty = utility.propCheck( propsState.qty, "" );
			code = utility.propCheck( propsState.code, "" );
			description = utility.propCheck( propsState.description, "" );
			isUorM = utility.propCheck( propsState.isUorM, "" );
			price = utility.propCheck( propsState.price, "" );
			amount = utility.propCheck( propsState.amount, "" );
        }

        return (
            <ErrorBoundary>
                <BillableItemConnect itemId={itemId} qty={qty} code={code} description={description} isUorM={isUorM} price={price} amount={amount} editing={editing} studyId={studyId} studyName={studyName} returnPath={returnPath} />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/EditBillableItem.js